import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="inline-block font-heading text-2xl font-bold tracking-tight text-background-50 hover:text-primary-400 transition-colors">
                Vigorbuy<span className="text-primary-400">.</span>
              </Link>
              <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-xs">
                Your trusted destination for the most comprehensive Vigorbuy Spreadsheet directory. Discover verified products, trusted sellers, and expert buying guides.
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Vigorbuy Sheet</a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Buy It Now</a>
                <Link to="/guide/vigorbuy-spreadsheet-guide" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Buying Guide</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Top Categories</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Shoes</a>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Hoodies &amp; Sweaters</a>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-primary-400 transition-colors">T-Shirts</a>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Jackets</a>
                <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Bags</a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/guide/vigorbuy-spreadsheet-guide" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Vigorbuy Spreadsheet Guide</Link>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Trusted Sellers</Link>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">QC Resources</Link>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Shipping Guides</Link>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-primary-400 hover:border-primary-400 transition-all duration-200">
                <i className="ri-global-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-primary-400 hover:border-primary-400 transition-all duration-200">
                <i className="ri-shopping-bag-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-primary-400 hover:border-primary-400 transition-all duration-200">
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}